import {
  Avatar,
  Badge,
  Chip,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Modal,
  Stack,
} from '@mui/material';
import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import StarIcon from '@mui/icons-material/Star';
import { pink, red, yellow, green, amber } from '@mui/material/colors';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import SvgIcon from '@mui/material/SvgIcon';

export function SvgIconCrown(props) {
  return (
    <SvgIcon {...props}>
      {/* credit: plus icon from https://heroicons.com/ */}
      <svg
        xmlns='http://www.w3.org/2000/svg'
        fill='none'
        viewBox='0 0 24 24'
        strokeWidth={1.5}
        stroke='currentColor'
      >
        {/* <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M4.5 12a7.5 7.5 0 0015 0m-15 0a7.5 7.5 0 1115 0m-15 0H3m16.5 0H21m-1.5 0H12m-8.457 3.077l1.41-.513m14.095-5.13l1.41-.513M5.106 17.785l1.15-.964m11.49-9.642l1.149-.964M7.501 19.795l.75-1.3m7.5-12.99l.75-1.3m-6.063 16.658l.26-1.477m2.605-14.772l.26-1.477m0 17.726l-.26-1.477M10.698 4.614l-.26-1.477M16.5 19.794l-.75-1.299M7.5 4.205L12 12m6.894 5.785l-1.149-.964M6.256 7.178l-1.15-.964m15.352 8.864l-1.41-.513M4.954 9.435l-1.41-.514M12.002 12l-3.75 6.495'
    /> */}
        <path
          // fill={sx?.color || 'currentColor'}
          // fill-opacity='1'
          strokeLinejoin='round'
          d='M 5,16L 3,5.00001L 8.49999,12L 12,5.00001L 15.5,12L 21,5.00001L 19,16L 5,16 Z M 19,19C 19,19.5523 18.5523,20 18,20L 6.00001,20C 5.44772,20 5.00001,19.5523 5.00001,19L 5,18L 19,18L 19,19 Z '
        />
      </svg>
    </SvgIcon>
  );
}

const cirColors = (value) => {
  if (value < 40) {
    return 'error';
  } else if (value < 60) {
    return '#ffeb3b';
  } else {
    return 'success';
  }
};

const circleColor = (value, theme) => {
  if (value < 40) {
    return red[theme.palette.mode === 'dark' ? 800 : 600];
  } else if (value < 60) {
    return amber[theme.palette.mode === 'dark' ? 600 : 600];
  } else {
    return green[theme.palette.mode === 'dark' ? 800 : 600];
  }
};

const grColors = (value) => {
  if (value < 30) {
    return '#EA0609';
  } else if (value < 50) {
    return '#9e9e9e';
    // return '#854209';
  } else if (value < 70) {
    return '#9e9e9e';
    // return '#615908';
  } else {
    // return '#1C8208';
    return '#ffd600';
  }
};

const rateColors = (value) => {
  if (value < 30) {
    return 'darkred';
  } else if (value < 50) {
    return 'chocolate';
  } else if (value < 70) {
    return 'midnightblue';
  } else {
    return 'darkgreen';
  }
};

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

function CircularProgressWithLabel(props) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress
        variant='determinate'
        {...props}
        size={24}
        // color={cirColors(props.value)}
        // sx={{
        //   color: grColors(props.value),
        // }}
        sx={{
          color: (theme) => circleColor(props.value, theme),
        }}
        thickness={5}
        // variant={'indeterminate'} // вращается
        // | 'primary'
        // | 'secondary'
        // | 'error'
        // | 'info'
        // | 'success'
        // | 'warning'
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant='caption' component='div' color='text.secondary'>
          {props.title}
        </Typography>
      </Box>
    </Box>
  );
}
// import DiscreteLine from './DiscreteLine.jsx';
// import { getLocalDate } from '../utils/fn.js';
// import DiscreteLineV2 from './DiscreteLineV2.jsx';

// const Item = styled(Paper)(({ theme, dark, light, py, isdone, visible }) => ({
//   backgroundColor:
//     visible === 'false'
//       ? theme.palette.mode === 'dark'
//         ? '#7a3b27'
//         : '#ffad93'
//       : theme.palette.mode === 'dark'
//       ? isdone === 'done'
//         ? '#1b5e20'
//         : theme.palette.secondary
//       : light,
//   ...theme.typography.body2,
//   padding: theme.spacing(0),
//   paddingTop: theme.spacing(py),
//   paddingBottom: theme.spacing(py),
//   //marginRight: theme.spacing(1),
//   textAlign: 'center',
//   color: theme.palette.mode === 'dark' ? dark : theme.palette.text.disabled,
//   cursor: 'pointer',
// }));

const TypeHeader = ({ showStages, showCreatedAt, matchDownMd, stages }) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // function getBgColorDark(state) {
  //   if (state === 'done') {
  //     return '#4caf50';
  //   } else {
  //     return '#d3d3d3';
  //   }
  // }

  // function getBgColorLight(state) {
  //   if (state === 'done') {
  //     return '#a5d6a7';
  //   } else {
  //     return '#d3d3d3';
  //   }
  // }

  //console.log('showStages', showStages);
  return (
    <>
      <Grid
        container
        spacing={0}
        sx={{ mt: 1 }}
        onClick={handleOpen}
        // alignItems='center'
        // sx={{
        //   bgcolor: !project.visible
        //     ? palette.mode === 'dark'
        //       ? '#3e2723'
        //       : '#ffebee'
        //     : null,
        //   color: !project.visible && palette.text.disabled,
        //   py: userInfo?.isAdmin && !userInfo?.readOnly ? 0 : 1,
        // }}
      >
        {matchDownMd ? (
          <>
            <Grid
              item
              xs={matchDownMd ? 12 : 7}
              //onClick={() => goto(project._id) }
            >
              {/* <Grid container spacing={0}>
                {Array.isArray(stages) &&
                  stages.map((item, index) => (
                    <Grid
                      item
                      xs
                      key={index}
                      sx={{
                        ml: 0,
                        pl: 0,
                        pb: showStages ? 0 : 1,
                        textAlign: 'center',
                        fontSize: '10px',
                      }}
                    >
                      {item?.percent >= 75 && <ThumbUpIcon color='success' />}
                      {item?.percent <= 25 && <ThumbDownIcon color='error' />}
                    </Grid>
                  ))}
              </Grid> */}
              <Grid container spacing={0}>
                {Array.isArray(stages) &&
                  stages.map((item, index) => (
                    <Grid
                      item
                      xs
                      key={index}
                      sx={{
                        ml: 0,
                        pl: 0,
                        pb: showStages ? 0 : 1,
                        textAlign: 'center',
                        fontSize: '10px',
                      }}
                    >
                      <CircularProgressWithLabel
                        title={item?.done}
                        value={item?.percent}
                      />
                      {/* {item?.percent >= 75 && <ThumbUpIcon color='success' />}
                      {item?.percent <= 25 && <ThumbDownIcon color='error' />} */}
                    </Grid>
                  ))}
              </Grid>
            </Grid>
            <Grid item xs={12} container>
              <Grid
                item
                xs={9}
                sx={{ ml: 0, pl: 0, pb: showStages ? 0 : 1, fontSize: '12px' }}
              >
                <span>{'Наименование'}</span>
              </Grid>
              <Grid
                item
                xs={3}
                sx={{
                  ml: 0,
                  pl: 0,
                  pb: showStages ? 0 : 1,
                  textAlign: 'right',
                  fontSize: '12px',
                }}
              >
                <span> {showCreatedAt ? 'Создан' : 'Срок'} </span>
              </Grid>
            </Grid>
          </>
        ) : (
          <>
            <Grid item xs={5} container>
              <Grid
                item
                xs={9}
                sx={{ ml: 0, pl: 0, pb: showStages ? 0 : 1, fontSize: '12px' }}
              >
                <span>{'Наименование'}</span>
              </Grid>
              <Grid
                item
                xs={3}
                sx={{
                  ml: 0,
                  pl: 0,
                  pb: showStages ? 0 : 1,
                  textAlign: 'center',
                  fontSize: '12px',
                }}
              >
                {showCreatedAt ? 'Создан' : 'Срок'}
              </Grid>
            </Grid>
            <Grid
              item
              xs={matchDownMd ? 12 : 7}
              //onClick={() => goto(project._id) }
            >
              {/* <Grid container spacing={0}>
                {Array.isArray(stages) &&
                  stages.map((item, index) => (
                    <Grid
                      item
                      xs
                      key={index}
                      sx={{
                        ml: 0,
                        pl: 0,
                        pb: showStages ? 0 : 1,
                        textAlign: 'center',
                        fontSize: '10px',
                      }}
                    >
                      {item?.percent >= 75 && <ThumbUpIcon color='success' />}
                      {item?.percent <= 25 && <ThumbDownIcon color='error' />}
                    </Grid>
                  ))}
              </Grid> */}
              <Grid container spacing={0}>
                {Array.isArray(stages) &&
                  stages.map((item, index) => (
                    <Grid
                      item
                      xs
                      key={index}
                      sx={{
                        ml: 0,
                        pl: 0,
                        pb: showStages ? 0 : 1,
                        textAlign: 'center',
                        fontSize: '10px',
                      }}
                    >
                      <CircularProgressWithLabel
                        title={item?.done}
                        value={item?.percent}
                      />
                    </Grid>
                  ))}
              </Grid>
            </Grid>
          </>
        )}
      </Grid>
      <Modal
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={style}>
          <Typography id='modal-modal-title' variant='h6' component='h2'>
            Лидеры и отстающие:
          </Typography>
          <List
            dense={true}
            sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
          >
            {Array.isArray(stages) &&
              stages
                // .sort((a, b) => a.percent - b.percent)
                .map((item, index) => (
                  <ListItem
                    key={index}
                    secondaryAction={
                      <Stack direction={'row'} gap={1}>
                        {/* {item?.percent >= 75 && (
                          <span>
                            <ThumbUpIcon
                              sx={{ color: '#ffd600' }}
                              // color='success'
                            />
                          </span>
                        )}
                        {item?.percent <= 25 && (
                          <span>
                            <ThumbDownIcon color='error' />
                          </span>
                        )} */}
                        <Chip
                          sx={{
                            color: (theme) => circleColor(item?.percent, theme),
                            fontWeight: 'bold',
                          }}
                          label={`${item?.percent}%`}
                          // color={cirColors(item?.percent)}
                          variant='outlined'
                          // {
                          //   ['error', 'success'].includes(
                          //     cirColors(item?.percent)
                          //   )
                          //     ? 'filled'
                          //     : 'outlined'
                          // }
                        />
                      </Stack>
                    }
                  >
                    {/* <ListItemAvatar>
                    <CircularProgressWithLabel
                      title={item?.done}
                      value={item?.percent}
                    />
                  </ListItemAvatar> */}
                    <ListItemText
                      // sx={{
                      //   backgroundColor: rateColors(item?.percent),
                      // }}
                      primary={item?.title}
                      // secondary='Jan 9, 2014'
                    />
                  </ListItem>
                  // <Grid
                  //   item
                  //   xs
                  //   key={index}
                  //   sx={{
                  //     ml: 0,
                  //     pl: 0,
                  //     pb: showStages ? 0 : 1,
                  //     textAlign: 'center',
                  //     fontSize: '10px',
                  //   }}
                  // >
                  //   <CircularProgressWithLabel
                  //     title={item?.done}
                  //     value={item?.percent}
                  //   />
                  // </Grid>
                ))}
          </List>
          {/* <Typography id='modal-modal-description' sx={{ mt: 2 }}>
            Duis mollis, est non commodo luctus, nisi erat porttitor ligula.
          </Typography> */}
        </Box>
      </Modal>
    </>
  );
};

export default TypeHeader;
